import { Outlet, useMatch } from '@tanstack/react-router'
import { useMeasure } from '@uidotdev/usehooks'
import { FC } from 'react'

import { StyledRootLayoutContainer, StyledRootLayoutContent } from '../styles'
import { RootLayoutFooter } from './RootLayoutFooter'
import { RootLayoutHeader } from './RootLayoutHeader'

export const RootLayout: FC = () => {
  const dashboardRoute = useMatch({
    from: '/_authenticated/account/_dashboard',
    shouldThrow: false,
  })

  const [navBarRef, { height: navBarHeight }] = useMeasure()

  return (
    <StyledRootLayoutContainer
      style={{ '--nav-bar-height': `${navBarHeight}px` }}
      $isDashboardRoute={!!dashboardRoute}
    >
      <RootLayoutHeader ref={navBarRef} />
      <StyledRootLayoutContent>
        <Outlet />
      </StyledRootLayoutContent>
      <RootLayoutFooter />
    </StyledRootLayoutContainer>
  )
}
